import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import BeachChairWithSun from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BeachChairWithSun';
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
import GraduationHatWithTassle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/GraduationHatWithTassle';
import HandWithThreePlusSigns from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HandWithThreePlusSigns';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'brokerage-accounts-services-what-is-it',
    icon: HandWithThreePlusSigns,
    title: 'Standard Brokerage',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Have access to a variety of investments that lets you use your money however you want, with no contribution limits or withdrawal restrictions.
      </Typography>
    ),
  },
  {
    id: 'brokerage-accounts-services-why-do-i-need-it',
    icon: BeachChairWithSun,
    title: 'Individual Retirement Account (IRA)',
    contentAs: 'div',
    content: (
      <>
        <Typography
          align='left'
          nextElement='link'>
          Be able to invest in stocks, bonds, mutual funds, ETFs, and more to help you grow your funds in a tax&#45;advantaged way that you can use in retirement.
        </Typography>
        <Link
          id='brokerage-accounts-services-understanding-product-retirement-link'
          variant='buttonLinkTertiary'
          linkUrl='/iras-and-retirement-plans/'
          ariaLabel='Learn more about how Northwestern Mutual can help with retirement.'
          endAdornment={CaratRight}
          endAdornmentStylesReset>
          Find out more
        </Link>
      </>
    ),
  },
  {
    id: 'brokerage-accounts-services-is-it-affordable',
    icon: GraduationHatWithTassle,
    title: '529 Education Savings',
    contentAs: 'div',
    content: (
      <>
        <Typography
          align='left'
          nextElement='link'>
          This type of tax&#45;advantaged account helps you save and grow funds for a child&#39;s higher education expenses or tuition for elementary or secondary schools.
        </Typography>
        <Link
          id='brokerage-accounts-services-understanding-product-college-savings-plans-link'
          variant='buttonLinkTertiary'
          linkUrl='/529-college-savings-plans/'
          ariaLabel='Learn more about college savings plans.'
          endAdornment={CaratRight}
          endAdornmentStylesReset>
          Find out more
        </Link>
      </>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='brokerage-accounts-services'
      backgroundVariant='lightB'
      headingText={<>See which type of brokerage account might fit <WidowBlock>your goals</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
